<template>
  <div class="the-navbar__user-meta flex items-center" v-if="activeUserInfo.displayName">
    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ getUserInfo.name }}</p>
      <small>{{getUserInfo.role }}</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
      <div class="con-img ml-3">
        <img 
          key="onlineImg"
          :src="clientLogo"
          alt="user-img"
          width="40"
          height="40"
          class="rounded-full shadow-md cursor-pointer block"
        />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">
          <vs-divider class="m-1" />

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout"
          >
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import axios from "@/axios.js";

export default {
  data() {
    return {
      activeUserInfo: {
        uid: 0, // From Auth
        displayName: "test", // From Auth

        about: " ",
        photoURL: "", // From Auth
        status: "online",
        userRole: "admin",
      },
    };
  },
  computed: {
    getUserInfo() {
      var UserInfo = localStorage.getItem("userInfo");

      if (UserInfo != null && UserInfo != "") {
        var theUserInfo = JSON.parse(UserInfo);

        return theUserInfo;
      }
      return { name: "", email: "", role: "" };
    },
    clientLogo() {
      console.log(
        "url3333333333333:",
        axios.defaults.baseURL + "/storage/" + this.getUserInfo.logo
      );

      if(this.getUserInfo.logo == "" || this.getUserInfo.logo == null){
         return require("@/assets/images/portrait/small/user.png");
      }

      return axios.defaults.baseURL + "/storage/" + this.getUserInfo.logo;
    },

    // activeUserInfo() {
    //   return this.$store.state.AppActiveUser
    // }
  },
  methods: {
    logout() {
      localStorage.removeItem("permission");
      localStorage.removeItem("token");
      localStorage.removeItem("userInfo");
      this.$router.push("/login").catch(() => {});
    },
  },
};
</script>